<template>
  <div class="ls_spin_container">
    <h1 class="company_header">{{ formData.full_name }}</h1>
    <Tabs style="height: 100%">
      <TabPane label="Основные">
        <Card style="width:850px">
          <Form ref="formData" :model="formData" :rules="rules">
            <input type="text" style="display:none" />
            <input type="password" style="display:none" />

            <!-- LAST NAME -->
            <FormItem prop="last_name" :label="schema.last_name.label">
              <Input
                v-model="formData.last_name"
                :placeholder="schema.last_name.label"
              />
            </FormItem>

            <!-- FIRST NAME -->
            <FormItem prop="first_name" :label="schema.first_name.label">
              <Input
                v-model="formData.first_name"
                :placeholder="schema.first_name.label"
              />
            </FormItem>

            <!-- MIDDLE NAME -->
            <FormItem prop="middle_name" :label="schema.middle_name.label">
              <Input
                v-model="formData.middle_name"
                :placeholder="schema.middle_name.label"
              />
            </FormItem>

            <div>
              <Button v-if="!showEditPassword" @click="showEditPassword = true"
                >Сменить пароль</Button
              >
              <Button v-if="showEditPassword" @click="showEditPassword = false"
                >Скрыть форму смены пароля</Button
              >
            </div>

            <div v-if="showPassword">

              <!-- OLD PASSWORD -->
              <FormItem
                prop="old_password"
                label="Старый пароль"
              >
                <Input
                  type="password"
                  v-model="formData.old_password"
                  placeholder="Старый пароль"
                  autocomplete="old-password"
                />
              </FormItem>

              <!-- NEW PASSWORD -->
              <FormItem
                prop="new_password"
                label="Новый пароль"
              >
                <Input
                  type="password"
                  v-model="formData.new_password"
                  placeholder="Новый пароль"
                  autocomplete="new-password"
                />
              </FormItem>
            </div>

            <FormItem>
              <Button
                style="float: right"
                type="primary"
                @click="saveAction()"
                :disabled="disabledSaveButton"
                >Сохранить</Button
              >
              <!--<Button type="primary" @click="saveAction()" :disabled="!validForm">Сохранить</Button>-->
            </FormItem>
          </Form>
          <Spin size="large" fix v-if="loading"></Spin>
        </Card>
      </TabPane>
    </Tabs>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { base_url } from "../../http.js";

export default {
  name: "currentUser",
  data() {
    return {
      // action: "edit",
      base_view_url: base_url + "/current_user/",
      metadata_url: base_url + "/current_user/",
      loading: true,
      // baseRules: {},
      // excludeFieldsRules: [],
      validForm: false,
      isChanged: false,

      formData: {
        last_name: "",
        first_name: "",
        middle_name: "",
        old_password: "",
        new_password: ""
      },

      rules: {
        last_name: [
          {
            required: true,
            message: "Пожалуйста, заполните поле",
            trigger: "change"
          }
        ],
        first_name: [
          {
            required: true,
            message: "Пожалуйста, заполните поле",
            trigger: "change"
          }
        ],
        old_password: [
          {
            required: true,
            message: "Пожалуйста, заполните поле",
            trigger: "change"
          }
        ],
        new_password: [
          {
            required: true,
            message: "Пожалуйста, заполните поле",
            trigger: "change"
          }
        ]
      },

      showEditPassword: false
    };
  },
  asyncComputed: {
    schema: {
      get() {
        return this.$http.options(this.metadata_url).then(response => {
          let schema = response.data.actions.PUT;
          return schema;
        });
      }
    }
  },
  computed: {
    showPassword() {
      return this.showEditPassword;
    },

    disabledSaveButton() {
      return !this.isChanged || !this.validForm;
    }
  },
  methods: {
    fetchCurrentUser() {
      this.loading = true;
      this.$http
        .get(this.base_view_url)
        .then(response => {
          this.formData = response.data;

          let data = response.data;
          this.$store.commit("user_id", data.id);
          this.$store.commit("user_full_name", data.full_name);
          this.$store.commit("currency", data.currency);
          this.$store.commit("permissions", data.permissions);
          this.$store.commit("role", data.role);
          this.$store.commit("role_display", data.role_display);
          this.$store.commit("cashes", data.cashes);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    validateForm() {
      this.$refs.formData.validate(valid => {
        this.validForm = valid;
      });
    },

    saveAction() {
      if (this.validForm) {
        this.save();
      } else {
        this.$Message.error("Некорректно заполнены поля!");
      }
    },

    save() {
      this.loading = true;
      this.$http
        .put(this.base_view_url, this.formData)
        .then(response => {
          this.$Message.success("Успешно сохранено");
          this.isChanged = false;
          this.fetchCurrentUser();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    this.loading = true;
  },
  mounted() {
    this.fetchCurrentUser();
  },
  watch: {
    "formData.last_name": function(to, from) {
      this.validateForm();
      this.isChanged = true;
    },
    "formData.first_name": function(to, from) {
      this.validateForm();
      this.isChanged = true;
    },
    "formData.middle_name": function(to, from) {
      this.validateForm();
      this.isChanged = true;
    },
    "formData.old_password": function(to, from) {
      this.validateForm();
      this.isChanged = true;
    },
    "formData.new_password": function(to, from) {
      this.validateForm();
      this.isChanged = true;
    }
  }
};
</script>

<style scoped>
.company_header {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/apps/user/currentUser.vue